import { ObservableArray, View } from "binder"
import { ServerSideDataLoader } from "uicomponents";
import { BalanceSheetViewModel, singleBalance } from "./balanceSheet-viewModel"

export class BalanceSheetView extends View<BalanceSheetViewModel>{
    GetViewUniqueId(): string {
        return "V-C156E7B6-226A-4887-A6EE-5BE33E46DF43"
    }
    loadHtml(): string {
        let element = require('./balanceSheet.html').default;
        let style = require('./balanceSheet.less');
        return element;
    }
    constructor() {
       super();
    }
    
    // public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set balances(v: ObservableArray<singleBalance>) { this._balances = v; } public get balances(): ObservableArray<singleBalance> { return this._balances;} private _balances: ObservableArray<singleBalance>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set date(v: moment.Moment) { this._date = v; } public get date(): moment.Moment { return this._date;} private _date: moment.Moment;

    refresh(){
        this.dataContext.refresh();
    }
}
